import { z } from "zod";
import { defineEndpoint } from "../endpoint.js";
import { stockQtySchema } from "../inventory.js";
import { paisa } from "../money.js";
import { PAYMENT_METHODS } from "../payments.js";
import { billNumberSchema } from "./commands.js";
/**
 * A counter bill looked up by number for a return (POS-07, docs/specs/pos-app.md "Returns and exchanges (B-50)"):
 * bills not on this device — another counter or branch of the shop. Device tokens only.
 */
export const posBillParamsSchema = z.object({
    /** As printed on the receipt (its barcode); case-insensitive. */
    number: z.string().trim().toUpperCase().pipe(billNumberSchema),
});
export const posBillLineSchema = z.object({
    orderLineId: z.uuid(),
    variantId: z.uuid(),
    name: z.string(),
    sku: z.string(),
    unitPrecision: z.int().min(0).max(3),
    /** Base units sold, and already returned (any device). */
    qty: stockQtySchema,
    returnedQty: stockQtySchema,
    unitPricePaisa: paisa(),
    /** What the line cost the customer (after discounts, VAT included): the refund basis. */
    paidPaisa: paisa(),
    /** Already refunded for the line by earlier returns. */
    refundedPaisa: paisa(),
});
export const posBillSchema = z.object({
    orderId: z.uuid(),
    number: z.string(),
    locationId: z.uuid(),
    occurredAt: z.iso.datetime(),
    customer: z.object({ id: z.uuid(), name: z.string(), phone: z.string().nullable() }).nullable(),
    lines: z.array(posBillLineSchema),
    /** Total + cash rounding: what the customer was charged. */
    payablePaisa: paisa(),
    roundingPaisa: paisa(),
    payments: z.array(z.object({ method: z.enum(PAYMENT_METHODS), amountPaisa: paisa() })),
    /** The part left on the customer's dues, and how much of it earlier returns already took back (dues first). */
    duesPaisa: paisa(),
    duesRefundedPaisa: paisa(),
});
export const getPosBill = defineEndpoint({
    tag: "pos-sync",
    name: "getPosBill",
    method: "GET",
    path: "/v1/pos/bills/{number}",
    access: { device: true },
    summary: "A counter bill of this shop by its number, with what was already returned (POS returns)",
    params: posBillParamsSchema,
    status: 200,
    response: posBillSchema,
});
//# sourceMappingURL=bills.js.map